import { get } from 'svelte/store';
import { db, type AuditAction, type AuditEntry } from './db';
import { authState } from './auth';
import { newId } from './ids';

export async function logAudit(
  action: AuditAction,
  details: Omit<Partial<AuditEntry>, 'id' | 'actor' | 'action' | 'at'>,
): Promise<void> {
  const actor = get(authState).email ?? 'anonymous';
  const entry: AuditEntry = {
    id: newId(),
    action,
    actor,
    at: Date.now(),
    ...details,
  };
  await db.audit.add(entry);
}

export async function auditFor(treeId: string, limit = 200): Promise<AuditEntry[]> {
  return db.audit
    .where('treeId').equals(treeId)
    .reverse()
    .sortBy('at')
    .then((rows) => rows.slice(0, limit));
}
